import React from "react";
import { Icon, type IconProps } from "@chakra-ui/react";

export function TrendIcon(props: IconProps) {
  return (
    <Icon width="20px" height="20px" viewBox="0 0 20 20" fill="none" {...props}>
      <g stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="m19.167 5-7.917 7.917L7.083 8.75.833 15" />
        <path d="M14.167 5h5v5" />
      </g>
    </Icon>
  );
}
